import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@school/ui-lib/src/styles/tokens.css'
import './tokens.css'
import './index.css'
import App from './App.tsx'
import { AppErrorBoundary } from './components/AppErrorBoundary'

// Vite fires `vite:preloadError` when a dynamic-import chunk fails to load -
// the stale-index.html case described in AppErrorBoundary. It fires for the
// module preloads React.lazy triggers, which is often BEFORE any component
// throws, so catching it here recovers without the error card appearing at all.
// Reload once, guarded, so it can never loop.
window.addEventListener('vite:preloadError', () => {
  try {
    const KEY = 'app_chunk_reload_at';
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (last && Date.now() - last < 20_000) return; // already reloaded - let the boundary show Retry
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* sessionStorage unavailable - reload anyway */ }
  // A plain location.reload() can be answered from the HTTP cache, which is the
  // stale index.html being escaped. A URL the browser has not seen forces a
  // real network fetch.
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('_r', String(Date.now()));
    window.location.replace(url.toString());
  } catch {
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
)
